import { useLocation } from 'react-router-dom';

/**
 * Returns a function isActive(path) that matches:
 *   - exact equality for "/"
 *   - prefix-startsWith for everything else (so /strategies/abc activates
 *     the /strategies tab).
 */
export default function useActiveRoute() {
  const loc = useLocation();
  return (path) => {
    if (path === '/') return loc.pathname === '/';
    return loc.pathname === path || loc.pathname.startsWith(path + '/');
  };
}
